import { render, staticRenderFns } from "./GameDesign.vue?vue&type=template&id=0f06e6ca&"
import script from "./GameDesign.vue?vue&type=script&lang=js&"
export * from "./GameDesign.vue?vue&type=script&lang=js&"
import style0 from "./GameDesign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports